import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import HomeIcon from '@mui/icons-material/HomeRounded'

type CoreHeaderProps = {
    hideGoToMap?: boolean
}

const CoreHeader = (props: CoreHeaderProps) => {
    const { hideGoToMap } = props
    const { t } = useTranslation()

    return (
        <StyledContainer>
            <StyledDivTitle>
                <img
                    style={{ height: '50px', imageRendering: '-webkit-optimize-contrast' }}
                    src={`${process.env.REACT_APP_IMAGE_PATH}/assets/image/logo_system_name.png`}
                />
                <StyledDivSystemName>
                    <StyledTypoSystemName variant="subtitle1">{t('LABEL.SYSTEM_NAME')}</StyledTypoSystemName>
                    <StyledTypoSubSystemName variant="subtitle1">{'สำนักงาน กสทช.'}</StyledTypoSubSystemName>
                </StyledDivSystemName>
            </StyledDivTitle>
            {!hideGoToMap && (
                <StyledDivLink>
                    <StyledLink to="/">
                        <StyledDivLabelLink>
                            <IconHome />
                            <StyledTypoLink variant="subtitle1">{t('BUTTON.GO_TO_MAP')}</StyledTypoLink>
                        </StyledDivLabelLink>
                    </StyledLink>
                </StyledDivLink>
            )}
        </StyledContainer>
    )
}

export default CoreHeader

const StyledContainer = styled('div')(({ theme }) => ({
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0px',
    justifyContent: 'space-between',
    backgroundImage: theme.palette.getContrastText('gradient-header'),
    boxShadow: theme.palette.getContrastText('shadow-bottom'),
    [theme.breakpoints.down('sm')]: {
        padding: '10px 20px',
    },
}))

const StyledDivTitle = styled('div')(({ theme }) => ({
    width: '65%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '100px',
    [theme.breakpoints.down('sm')]: {
        paddingLeft: '0px',
    },
}))

const StyledDivSystemName = styled('div')(({ theme }) => ({
    display: 'block',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}))

const StyledTypoSystemName = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    },
}))

const StyledTypoSubSystemName = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
        fontSize: '9px',
    },
}))

const StyledDivLink = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    paddingRight: '100px',
    [theme.breakpoints.down('sm')]: {
        paddingRight: '0px',
    },
}))

const StyledDivLabelLink = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
}))

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.palette.text.secondary,
}))

const StyledTypoLink = styled(Typography)(({ theme }) => ({
    display: 'block',
    paddingLeft: '5px !important',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}))

const IconHome = styled(HomeIcon)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        fontSize: '30px',
    },
}))
